export enum ExpenseKind {
  TVPhoneInternet = 1,
  Transport = 2,
  Electricity = 3,
  Water = 4,
  Heating = 5,
  Insurance = 6,
}

export interface Expense {
  ID: string;
  LoanApplicationID: string;
  Kind: ExpenseKind;
  Value: number;
}

export interface CreateExpense {
  Kind: ExpenseKind;
  Value: number;
}

export interface UpdateExpense extends Partial<Expense> {
  ID: string;
}
